import React, { useEffect, useState } from "react";
import { useSetState } from "ahooks";
import dayjs from "dayjs";
import { Button, Form, message, Tooltip } from "antd";
import { SAlert, SDrawerOrModal, SGeneralForms } from "shj-components";
import { useAtom } from "jotai";
import { SPUDataAtom } from "@/pages/combinationManage/components/store.js";

import { getEnums } from "@/services/homeService.ts";
import {
  addCombinationProductInfo, getProductSkuList, getSpuPageList,
  productSearchList
} from "@/services/product.ts";
import ChooseSKUModal from "@/pages/combinationManage/components/ChooseSKUModal";
import { isArray } from "lodash-es";
import DebounceSearchSelect from '@/pages/baseProduct/components/DebounceSearchSelect'

const CopyModal = (props) => {
  const { open, onClose, record = {}, onReload } = props;
  const [SPUData, setSPUData] = useAtom(SPUDataAtom)
  const [form] = Form.useForm()
  const [loading, setLoading] = useState(false)
  const [spuUnit, setSpuUnit] = useState('')
  const [state, setState] = useSetState({
    SKUOpen: false,
  })
  const productId = Form.useWatch('productId', form);
  const startDate = Form.useWatch('startDate', form);

  useEffect(() => {
    if (open) {
      form.resetFields()
      form.setFieldsValue({
        ...record,
        startDate: record.startDate ? dayjs(record.startDate) : null,
        endDate: record.endDate ? dayjs(record.endDate) : null,
      })
      record.skuIds.length > 0 && getSkuList(record.skuIds)
      setSpuUnit(record?.unitInfo?.unitName)
      getOptions();
    }
  }, [open]);

  const disabledEndDate = (current) => {
    const date = startDate || dayjs(record.startDate);
    return current && current < date.startOf('day')
  }

  const getSkuList = (ids) => {
    getProductSkuList({ ids }).then(res => {
      setSPUData((SPUData) => ({ ...SPUData, chooseSku: isArray(res) ? res : [] }))
    })
  }

  const getOptions = async () => {
    try {
      setLoading(true)
      // const spuList = await productSearchList({ prodTypes: ['PRODUCT_SINGLE', 'PRODUCT_BASIC_ITEM'], enabled: true })
      const typeList = await getEnums('plus-product', 'com.shj.saas.plus.product.enums.ProductCombinationDetailSelectType')
      setLoading(false)
      return {
        typeList,
        // spuList,
      }
    } catch (e) {
      setLoading(false)
    }
  }
  console.log(SPUData)

  const onFinish = () => {
    form.validateFields().then(values => {
      if (SPUData.chooseSku?.length <= 0 && values.selectType !== 'ALL') {
        message.error('请选择至少一条SKU');
        return;
      }
      setLoading(true)
      const data = { ...record };
      ['createdBy', 'createdByName', 'createdTime', 'lastUpdatedTime', 'modifiedBy', 'modifiedByName', 'tenantId'].forEach(key => delete data[key])
      addCombinationProductInfo({
        ...data,
        ...values,
        id: undefined,
        skuIds: SPUData.chooseSku?.map(item => item.id),
        selectedSkuList: SPUData.chooseSku,
        startDate: values.startDate && dayjs(values.startDate).format('YYYY-MM-DD'),
        endDate: values.endDate && dayjs(values.endDate).format('YYYY-MM-DD'),
      }).then(res => {
        message.success(res.message || '操作成功')
        onClose?.()
        onReload?.()
        setSPUData(() => ({ dataSource: [], chooseSku: [] }))
      }).finally(() => setLoading(false))
    })
  }

  return <>
    <SDrawerOrModal
      title={'复制'}
      width={500}
      open={open}
      loading={loading}
      onCancel={() => {
        onClose();
        setSPUData({ dataSource: [], chooseSku: [] })
      }}
      onOk={onFinish}
    >
      <SAlert type="info">
        复制提交后，在组合下新增一行子产品数据
      </SAlert>
      <SGeneralForms
        layout={'vertical'}
        formConfig={{ form }}
        httpOptionsFn={getOptions}
        configs={[{
          formItem: [
            {
              spanCol: 24,
              label: '子产品SPU',
              name: 'productId',
              required: true,
              rules: [{ required: true, message: '子产品SPU不能为空' }],
              type: 'select',
              data: 'spuList',
              // comConfig: {
              //   onChange: (value, option) => {
              //     setSpuUnit(option?.unitInfo?.unitName);
              //     setSPUData((SPUData) => ({ ...SPUData, chooseSku: [] }))
              //   },
              //   fieldNames: { label: 'prodName', value: 'id' },
              //   filterOption: (inputValue, option) => {
              //     if (isNumber(Number(inputValue)) && [18, 19].includes(inputValue.length)) {
              //       return option?.id === inputValue || option?.label?.toLowerCase().indexOf(inputValue?.toLowerCase()) >= 0;
              //     }
              //     return option?.label?.toLowerCase().indexOf(inputValue?.toLowerCase()) >= 0;
              //   }
              // },
              children: (
                <DebounceSearchSelect
                  allowClear
                  label={'子产品SPU'}
                  isCommon={false}
                  fixedParams={{ prodTypes: ['PRODUCT_SINGLE', 'PRODUCT_BASIC_ITEM'], enabled: true }}
                  fetchOptions={getSpuPageList}
                  fieldNames={{ label: 'prodName', value: 'id' }}
                  nameKey={'excludeCombinationKeyword'}
                  query={{ id: productId }}
                  onChange={(value, option) => {
                    value && form.setFieldsValue({ productId: value })
                    setSpuUnit(option?.unitInfo?.unitName)
                    setSPUData((SPUData) => ({ ...SPUData, chooseSku: [] }))
                  }}
                />
              ),
            },
            {
              spanCol: 24,
              isDeps: true,
              deps: () => spuUnit,
              customRender: () => {
                return <div
                  style={{ marginLeft: 10, marginTop: -10, marginBottom: 5, color: '#a6a6a6' }}>单位：{spuUnit}</div>
              },
            },
            {
              spanCol: 24,
              label: '数量',
              name: 'size',
              required: true,
              rules: [{ required: true, message: '数量不能为空' }],
              type: 'inputNumber',
              comConfig: {
                min: 0.0001,
                max: 999999999.9999,
                precision: 4
              }
            },
            {
              spanCol: 24,
              label: '开始日期',
              name: 'startDate',
              required: true,
              rules: [{ required: true, message: '开始日期不能为空' }],
              type: 'date',
              comConfig: {
                disabledDate: (current) => {
                  return current && current < dayjs().startOf('day');
                }
              }
            },
            {
              spanCol: 24,
              label: '结束日期',
              name: 'endDate',
              type: 'date',
              comConfig: {
                disabledDate: disabledEndDate
              }
            },
            {
              spanCol: 24,
              label: '附图顺序',
              name: 'picSort',
              type: 'inputNumber',
              comConfig: {
                min: 1,
                max: 999999999,
                precision: 0
              }
            },
            {
              spanCol: 24,
              label: 'SKU包含类型',
              name: 'selectType',
              required: true,
              rules: [{ required: true, message: '数量不能为空' }],
              type: 'select',
              data: 'typeList',
              comConfig: {
                fieldNames: { label: 'description', value: 'key' }
              }
            },
            {
              spanCol: 24,
              label: 'SKU选择',
              required: true,
              isDeps: true,
              deps: (form) => form.getFieldValue('selectType') !== 'ALL',
              children: (form) => {
                return <>
                  <Button type={'primary'} onClick={() => setState({ SKUOpen: true })}>SKU选择</Button>
                  {SPUData.chooseSku?.map(item => <Tooltip title={item.skuName} key={item.id}>
                    <div style={{
                      marginTop: 4,
                      whiteSpace: 'nowrap',
                      overflow: 'hidden',
                      textOverflow: 'ellipsis'
                    }}>{item.skuName}</div>
                  </Tooltip>)}
                </>
              },
            },
          ]
        }]}
      />
    </SDrawerOrModal>
    {state.SKUOpen && <ChooseSKUModal
        spuData={{}}
        changeDataSource={false}
        productId={productId}
        open={state.SKUOpen}
        onClose={() => setState({ SKUOpen: false })}
    />}
  </>
}

export default CopyModal